import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Paper, Grid, Box, IconButton, Typography, Divider } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CmpProjectStatusIcon from './CmpProjectStatusIcon';
import ChanceStatusIcon from '../../chancemng/info/ChanceStatusIcon';
import { getNumberComma } from '../../../utils/numberUtils';

const WhiteIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.background.paper,
}));

const WhiteTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.background.paper,
}));

/** 
 * 개별 정보 항목 컴포넌트 (가로 배치형)
 */
const ProjectInfoItem = ({ label, value, unit = '' }) => (
  <Box sx={{ 
    display: 'flex', 
    alignItems: 'center', 
    borderBottom: '1px dotted #e0e0e0', 
    pb: 0.5,
    mr: 1
  }}>
    <Typography sx={{ 
      width: 90, 
      fontWeight: 'bold', 
      fontSize: '0.8rem', 
      color: 'text.secondary',
      flexShrink: 0 
    }}>
      {label}
    </Typography>
    <Typography sx={{ 
      fontSize: '0.85rem', 
      fontWeight: '500', 
      color: 'text.primary',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }}>
      {value || '-'}{unit}
    </Typography>
  </Box>
);

const CmpProjectInfo = ({ project, handleGoBack }) => {
  const [projectStatus, setProjectStatus] = useState('');

  useEffect(() => {
    if (project) {
      setProjectStatus(project?.cmpGrade > 0 ? project.cmpStatus : project.cstStatus);
    }
  }, [project]);

  return (
    <Paper sx={{ mb: 2, overflow: 'hidden' }}>
      {/* 1. 슬림 헤더 */}
      <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#424242', px: 1, minHeight: 42 }}>
        <Box sx={{ p: 0.5 }}>
          <WhiteIconButton size="small" onClick={handleGoBack} sx={{ p: 0.5 }}>
            <ArrowBackIcon sx={{ fontSize: '1.1rem' }} />
          </WhiteIconButton>
        </Box>
        <Box sx={{ py: 0, display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <Box sx={{ display: 'flex', transform: 'scale(0.85)', transformOrigin: 'left center' }}>
            {project?.cmpGrade > 0 ? (
              <CmpProjectStatusIcon project={project} />
            ) : (
              <ChanceStatusIcon chance={project} />
            )}
          </Box>
          <Box sx={{ ml: 0.5 }}>
            <WhiteTypography sx={{ fontWeight: 'bold', fontSize: '1rem' }}>
              현재 단계: {projectStatus || '-'}
            </WhiteTypography>
          </Box>
        </Box>
      </Box>

      {/* 2. 프로젝트 상세 정보 영역 */}
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5, px: 1 }}>
          <SummarizeIcon fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>프로젝트 정보</Typography>
        </Box>
        <Divider sx={{ mb: 1, mx: 1 }} />

        <Box sx={{ px: 1, display: 'flex', flexDirection: 'column' }}>
          {/* 사업명 영역 */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            mt: 1.5, 
            pb: 1, 
            mb: 1.5, 
            borderBottom: '1px solid', 
            borderColor: 'divider' 
          }}>
            <Typography sx={{ width: 90, fontWeight: 'bold', color: 'text.secondary', fontSize: '0.85rem' }}>
              사업명
            </Typography>
            <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem', color: 'text.primary' }}>
              {project?.cstNm || '사업명 정보 없음'}
            </Typography>
          </Box>

          {/* 상세 정보 그리드 (4x2 형태) */}
          <Grid container rowSpacing={1.5} columnSpacing={2}>
            <Grid item xs={3}><ProjectInfoItem label="매출처명" value={project?.vendorCmpNm} /></Grid>
            <Grid item xs={3}><ProjectInfoItem label="매출 예상일" value={project?.expDay} /></Grid>
            <Grid item xs={3}><ProjectInfoItem label="예상 금액" value={getNumberComma(project?.expSales)} unit="원" /></Grid>
            <Grid item xs={3}><ProjectInfoItem label="예상 이익률" value={project?.expBenefitRate} unit="%" /></Grid>

            <Grid item xs={3}><ProjectInfoItem label="프로젝트 번호" value={project?.prjNo} /></Grid>
            
            <Grid item xs={3} sx={{ visibility: 'hidden' }}><ProjectInfoItem label="-" value="-" /></Grid>
            <Grid item xs={3} sx={{ visibility: 'hidden' }}><ProjectInfoItem label="-" value="-" /></Grid>
            <Grid item xs={3} sx={{ visibility: 'hidden' }}><ProjectInfoItem label="-" value="-" /></Grid>
          </Grid>
        </Box>
      </Box>
    </Paper>
  );
};

export default CmpProjectInfo;
